import React from "react";
import ReactDOM from "react-dom/client";
import { LazyMotion, domAnimation } from "framer-motion";
import "@/index.css";
import App from "@/App";
import { ContentProvider } from "@/content/ContentContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LazyMotion features={domAnimation} strict>
      <ContentProvider><App /></ContentProvider>
    </LazyMotion>
  </React.StrictMode>,
);
